import { DataEntry, FieldConfig } from '@common/components/MetadataCard';
import React, { useMemo } from 'react';

const resolveValue = (
    rawValue: unknown,
    formatter?: (val: unknown) => React.ReactNode,
): React.ReactNode => {
    const isEmpty =
        rawValue == null ||
        rawValue === '' ||
        (Array.isArray(rawValue) && rawValue.length === 0);

    if (isEmpty) return '-';

    if (formatter) return formatter(rawValue);

    return Array.isArray(rawValue)
        ? rawValue.join(', ')
        : (rawValue as React.ReactNode);
};

export const useMetadataMapper = <T extends object>(
    data: T | undefined | null,
    config: FieldConfig<T>[],
    resolveLabel: (key: keyof T) => string,
): DataEntry[] =>
    useMemo(() => {
        if (!data) return [];

        return config.map(({ key, formatter }) => ({
            label: resolveLabel(key),
            value: resolveValue(
                data[key],
                formatter as ((val: unknown) => React.ReactNode) | undefined,
            ),
        }));
    }, [data, config, resolveLabel]);
